import Vue from 'vue';
import Vuex from 'vuex';
import chat from './modules/Chat';
import profile from './modules/Profile';
import contact from './modules/Contact';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export const DialogStatus = {
  OPEN: 'open',
  MOVE: 'move',
  CLOSE: 'close',
  ACTIVE: 'active',
};

export default new Vuex.Store({
  state: {
    dialogStatus: DialogStatus.OPEN,
    reservationId: null,
    cusIdActive: null,
  },
  mutations: {
    SET_RESERVATION_ID(state, reservationId) {
      state.reservationId = reservationId;
    },
    SET_DIALOG_STATUS(state, status) {
      state.dialogStatus = status;
    },
    SET_CUSTOMER_ID(state, cusId) {
      state.cusIdActive = cusId;
    },
  },
  actions: {
    setReservationId({ commit }, reservationId) {
      commit('SET_RESERVATION_ID', reservationId);
    },
    setDialogStatus({ commit }, status) {
      commit('SET_DIALOG_STATUS', status);
    },
    setCusId({ commit }, cusId) {
      commit('SET_CUSTOMER_ID', cusId);
    },
  },
  getters: {
    dialogStatus: state => {
      return state.dialogStatus;
    },
    cusIdActive: state => {
      return state.cusIdActive;
    },
  },
  modules: {
    profile,
    chat,
    contact,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js